import {Form, Formik} from 'formik';
import React from 'react';
import * as Yup from 'yup';
import UseSendCode from '../auth/hooks/useSendCode';
import CustomButton from '../../components/mazraeKit/customButton';
import {PHONE_REGEX} from '../../utilities/helper/validation';
import ShopLogo from '../../assets/image/shopLogo.svg';
import {Link} from 'react-router-dom';
import FormikInput from '../../components/formikFileds/input';
import './style.css';
import formatPhoneNumStart09To9 from '../../utilities/helper/formatPhoneNumber';

interface IMyLoginCommand {
  phoneNumber: string;
}
const LoginSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('شماره تلفن اجباری می باشد')
    .matches(PHONE_REGEX, 'شماره تلفن را به درستی وارد نمایید'),
});
const Login = () => {
  const initialValues: IMyLoginCommand = {phoneNumber: ''};
  const {isLoading, mutate} = UseSendCode();

  return (
    <div className="flex w-full h-full gap-4 flex-col items-center justify-center">
      <div className="flex w-100 justify-center">
        <img src={ShopLogo} alt={'ShopLogo'} />
      </div>
      <div className="flex flex-col w-[70%] justify-center gap-2">
        <h1 className="p-0 m-0 text-gray-700 text-md font-Regular">ورود</h1>
        <p className="p-0 m-0 text-gray-700 text-sm font-Medium">
          جهت ورود به فروشگاه مزرعه شماره تلفن خود را وارد کنید.
        </p>
      </div>
      <Formik
        onSubmit={async values => {
          mutate({
            mobile: formatPhoneNumStart09To9(values.phoneNumber, true),
            app: 'supplier',
            country_code: '98',
          });
        }}
        initialValues={initialValues}
        validationSchema={LoginSchema}
        validateOnMount={true}
      >
        {({values, setFieldValue, isValid, errors}) => (
          <Form className="d-flex w-[65%] login-form-input  flex-col items-center gap-3">
            <FormikInput
              type="number"
              name="phoneNumber"
              label="شماره تلفن"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setFieldValue('phoneNumber', e.target.value);
              }}
              required={!values.phoneNumber}
            />
            <CustomButton
              type="submit"
              disabled={
                !isValid || !!(values.phoneNumber.length && errors.phoneNumber)
              }
              className=" w-full flex items-center justify-center rounded-[8px] text-white h-[32px] bg-farm-shop-500  disabled:bg-gray-700"
              title="دریافت کد"
              isLoading={isLoading}
            />
          </Form>
        )}
      </Formik>
      <p className="text-gray-700 font-Regular text-sm">
        با ورود به سایت مزرعه،{' '}
        <Link className="text-farm-shop-500 no-underline" to="/auth/rule">
          قوانین و مقررات
        </Link>{' '}
        را پذیرفته‌ام.
      </p>
    </div>
  );
};

export default Login;
